export default {
  sortArray(data, sortOn, dir) {
    let _data
    if (sortOn !== undefined && dir !== undefined) {
      _data = data.sort((a, b) => {
        const x = a[sortOn]
        const y = b[sortOn]
        if (dir.toUpperCase() === 'ASC') {
          return x < y ? -1 : x > y ? 1 : 0
        }
        if (dir.toUpperCase() === 'DESC') {
          return x > y ? -1 : x < y ? 1 : 0
        }
        return null
      })
    } else {
      _data = Array.from(new Set(data)).sort(function (a, b) {
        if (a[0] === b[0]) {
          var x = a['name']
          var y = b['name']
          return x < y ? -1 : x > y ? 1 : 0
        }
        return a[0] - b[0]
      })
    }
    return _data
  },
  sortArray2(data) {
    let _data = Array.from(new Set(data)).sort(function (a, b) {
      if (a[0] === b[0]) {
        var x = a['name']
        var y = b['name']
        return x < y ? -1 : x > y ? 1 : 0
      }
      return a[0] - b[0]
    })
    return _data
  },
  isJson(str) {
    try {
      JSON.parse(str)
    } catch (e) {
      return false
    }
    return true
  },
  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/globals.js